/**
 * StatusBadge Component
 * Displays game status as a colored chip
 */

import React from 'react';
import { Chip } from '@mui/material';
import { STATUS_LABELS, STATUS_COLORS } from '../../utils/constants';

export const StatusBadge = ({ status }) => {
  const label = STATUS_LABELS[status] || status;
  const color = STATUS_COLORS[status] || 'default';

  return (
    <Chip
      label={label}
      color={color}
      size="small"
      sx={{ fontWeight: 500 }}
    />
  );
};
